import React, { useEffect, useState } from 'react';
import {
  Col,
  Modal,
  Row,
  Switch,
  Button,
  Form,
  Card,
  notification,
  DatePicker,
} from 'antd';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import ParListSelect from 'components/ParListSelect';
import FormulaList from 'components/FormulaList';
import ThirdPartyInput from 'components/ThirdPartyInput';
import FormItem from 'antd/lib/form/FormItem';
import GetLabel from 'DisplayFramework/components/GetLabel';
import { toDatePickerDate } from 'utils/utils2';
import moment from 'moment';
import {
  PropThirdPartyRequest,
  updateProposalThirdParty,
} from 'services/proposal';
import BankAccountListSelect from 'pages/ThirdParty/ThirdPartyDetail/Components/BankAccListSelect';
import FormInput from 'components/FormInput';
import AddresseListSelect from 'pages/ThirdParty/ThirdPartyDetail/Components/AddressesListSelect';
import { useForm } from 'antd/lib/form/Form';
import IAdd from 'icons/IAdd';
import { onFinishFailed } from 'components/DisplayValidationErrors/DisplayValidationErrors';
import { isNil } from 'lodash';
import _ from 'lodash';

const initialValues = {
  tpname: '',
  ctrid: 0,
  enddate: '',
  mfagreedamount: 0,
  mfavailableamount: 0,
  mfbookedamount: 0,
  mfrequestedamount: 0,
  mfusedamount: 0,
  mfvaliditydate: '',
  startdate: toDatePickerDate(moment(Date.now()).format('YYYY-MM-DD')) as '',
  status: 'ACTIVE',
  statusdate: '',
  tpadrid: 0,
  tpbkidin: 0,
  tpbkidout: 0,
  tpblocklateinterestinvoicing: false,
  tpblockrejectionfeesinvoicing: false,
  tpblockreminderfeesinvoicing: false,
  tpid: 0,
  tplateinterestformula: '',
  tppaydelayin: '',
  tppaydelayout: '',
  tppaymodein: '',
  tppaymodeout: '',
  tprejectionfeesformula: '',
  tpreminderfeesformula: '',
  tprolecode: '',
  tproleid: 0,
};

export type TpdisplayProps = {
  tproleid?: number;
  addorupdate: 'ADD' | 'UPDATE';
  record?: any;
  onCancel: () => void;
  visible: boolean;
  onsave: (obj: PropThirdPartyRequest) => void;
  reftech?: () => void;
};

const Tpdisplay = (props: TpdisplayProps) => {
  const {
    reftech,
    onCancel,
    visible = false,
    record,
    onsave,
    addorupdate,
    tproleid,
  } = props;

  const [form] = useForm();
  useEffect(() => {
    if (addorupdate === 'UPDATE') {
      form.setFieldsValue({
        tpname: record?.tpname,
        ctrid: record?.ctrid,
        enddate: record?.enddate,
        mfagreedamount: record?.mfagreedamount,
        mfavailableamount: record?.mfavailableamount,
        mfbookedamount: record?.mfbookedamount,
        mfrequestedamount: record?.mfrequestedamount,
        mfusedamount: record?.mfusedamount,
        mfvaliditydate: record?.mfvaliditydate,
        startdate: toDatePickerDate(
          moment(Date.now()).format('YYYY-MM-DD')
        ) as '',
        status: 'ACTIVE',
        statusdate: record?.statusdate,
        tpadrid: record?.tpadrid,
        tpbkidin: record?.tpbkidin,
        tpbkidout: record?.tpbkidout,
        tpblocklateinterestinvoicing: record?.tpblocklateinterestinvoicing,
        tpblockrejectionfeesinvoicing: record?.tpblockrejectionfeesinvoicing,
        tpblockreminderfeesinvoicing: record?.tpblockreminderfeesinvoicing,
        tpid: {
          tpid: record?.tpid,
          tpname: record?.tpname,
          tpreference: record?.tpreference,
        },
        tplateinterestformula: record?.tplateinterestformula,
        tppaydelayin: record?.tppaydelayin,
        tppaydelayout: record?.tppaydelayout,
        tppaymodein: record?.tppaymodein,
        tppaymodeout: record?.tppaymodeout,
        tprejectionfeesformula: record?.tprejectionfeesformula,
        tpreminderfeesformula: record?.tpreminderfeesformula,
        tprolecode: record?.tprolecode,
        tproleid: record?.tproleid,
        bankAccountOut: record.tpbkidout ?? record?.bankAccountOut ?? -1,
        address: record.tpadrid ?? record?.address ?? -1,
        bankAccountIN: record.tpbkidin ?? record?.bankAccountIn ?? -1,
        tpmandatedate: !isNil(record.tpmandatedate)
          ? toDatePickerDate(record.tpmandatedate)
          : '',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  const handleFinish = (values: any) => {
    const header = {
      ...initialValues,
      ...values,
      tproleid:
        addorupdate === 'ADD' ? Math.round(_.random(10000) * 10000000) : tproleid,
      tpid: values.tpid.tpid.tpid,
      tpname: values.tpid.tpid.tpname,
      tpreference: values.tpid.tpid.tpreference,
      tpadrid: values.address,
    };
    if (addorupdate === 'ADD') {
      onsave({
        ...initialValues,
        ...values,
        tpid: values.tpid.tpid,
        tpname: values.tpid.tpname,
        tpreference: values.tpid.tpreference,
        tpadrid: values.address
      });
    } else {
      updateProposalThirdParty({
        request: header,
        tproleid: Number(tproleid),
      }).then((response) => {
        if (response.code === '200') {
          notification.success({ message: response.message });
          if (reftech) reftech();
        }
      });
    }
  };
  const [newRole, setRole] = useState('');
  return (
    <Modal
      visible={visible}
      title={
        addorupdate === 'ADD' ? (
          <GetLabel label="AddTp" />
        ) : (
          <GetLabel label="updateTp" />
        )
      }
      width="1200px"
      style={{ top: 100 }}
      onCancel={() => {
        onCancel();
        form.resetFields();
      }}
      footer={null}
    >
      <Card>
        <Form
          form={form}
          onFinish={handleFinish}
          onFinishFailed={onFinishFailed}
          layout="horizontal"
          initialValues={initialValues}
          labelCol={{ span: 24 }}
        >
          <Row>
            <Col span={21}></Col>
            <Col>
              <Button
                icon={
                  <IAdd
                    color="white"
                    width="14px"
                    height="14px"
                    svgstyle={{ marginTop: '3px' }}
                  />
                  // <IUpdate color="white" height="16px" width="13px" />
                }
                type="primary"
                onClick={() => form.submit()}
              >
                <GetLabel label={addorupdate === 'ADD' ? 'add' : 'update'}/>
              </Button>
            </Col>
          </Row>
          <Row gutter={16}>
            <FormInput
              comcode="tprolecode"
              name="tprolecode"
              col
              xs={6}
              shouldUpdate
            >
              <ParListSelect
                parcode="TPMAINROLE"
                onSelect={(e) => {
                  setRole(e);
                }}
              />
            </FormInput>
            <FormInput comcode="tpid" name="tpid" col xs={6} shouldUpdate>
              <ThirdPartyInput role={newRole} />
            </FormInput>
          </Row>
          <Row gutter={16}>
            <FormItem shouldUpdate noStyle>
              {({ getFieldValue }) => (
                <FormInput comcode="tpbkidin" name="tpbkidin" col xs={6}>
                  <BankAccountListSelect
                    params={{
                      tpid: record
                        ? record?.tpid.tpid
                        : getFieldValue('tpid')?.tpid,
                    }}
                  />
                </FormInput>
              )}
            </FormItem>
            <FormInput
              comcode="tppaymodein"
              name="tppaymodein"
              col
              xs={6}
              shouldUpdate
            >
              <ParListSelect parcode="PAYMODEIN" />
            </FormInput>

            <FormInput
              comcode="tppaydelayin"
              name="tppaydelayin"
              col
              xs={6}
              shouldUpdate
            >
              <ParListSelect parcode="PAYDELAYIN" />
            </FormInput>

            <FormInput name="tpmandatedate" col xs={6} shouldUpdate>
              <DatePicker />
            </FormInput>
          </Row>
          <Row gutter={16}>
            <FormItem shouldUpdate noStyle>
              {({ getFieldValue }) => (
                <FormInput
                  comcode="bankAccountOut"
                  name="tpbkidout"
                  col
                  xs={6}
                  shouldUpdate
                >
                  <BankAccountListSelect
                    params={{
                      tpid: record
                        ? record?.tpid.tpid
                        : getFieldValue('tpid')?.tpid,
                    }}
                  />
                </FormInput>
              )}
            </FormItem>

            <FormInput
              comcode="tppaymodeout"
              name="tppaymodeout"
              col
              xs={6}
              shouldUpdate
            >
              <ParListSelect parcode="PAYMODEOUT" />
            </FormInput>
            <FormInput
              comcode="tppaydelayout"
              name="tppaydelayout"
              col
              xs={6}
              shouldUpdate
            >
              <ParListSelect parcode="PAYDELAYOU" />
            </FormInput>
          </Row>
          <Row gutter={16}>
            <FormItem shouldUpdate noStyle>
              {({ getFieldValue }) => (
                <FormInput
                  comcode="address"
                  name="address"
                  col
                  xs={6}
                  shouldUpdate
                >
                  <AddresseListSelect
                    params={{
                      tpid: record
                        ? record?.tpid.tpid
                        : getFieldValue('tpid')?.tpid,
                    }}
                  />
                </FormInput>
              )}
            </FormItem>
          </Row>
          <Row>
            <FormInput
              comcode="tplateinterestformula"
              name="tplateinterestformula"
              col
              xs={6}
              shouldUpdate
            >
              <FormulaList
                params={{
                  ctecategory: '',
                  ctetype: 'LATEIN',
                  duration: 0,
                  finamount: 0,
                  priid: 0,
                  prilabel: '',
                  pristatus: '',
                }}
              />
            </FormInput>
            <Col span={2} />

            <FormInput
              comcode="tpblocklateinterestinvoicing"
              name="tpblocklateinterestinvoicing"
              col
              xs={3}
              shouldUpdate
              valuePropName="checked"
            >
              <Switch
                checkedChildren={<CheckOutlined />}
                unCheckedChildren={<CloseOutlined />}
              />
            </FormInput>
          </Row>
          <Row>
            <FormInput
              comcode="tprejectionfeesformula"
              name="tprejectionfeesformula"
              col
              xs={6}
              shouldUpdate
            >
              <FormulaList
                params={{
                  ctecategory: '',
                  ctetype: 'REJFEES',
                  duration: 0,
                  finamount: 0,
                  priid: 0,
                  prilabel: '',
                  pristatus: '',
                }}
              />
            </FormInput>
            <Col span={2} />
            <FormInput
              comcode="tpblockrejectionfeesinvoicing"
              name="tpblockrejectionfeesinvoicing"
              col
              xs={3}
              shouldUpdate
              valuePropName="checked"
            >
              <Switch
                checkedChildren={<CheckOutlined />}
                unCheckedChildren={<CloseOutlined />}
              />
            </FormInput>
          </Row>
          <Row>
            <FormInput
              comcode="tpreminderfeesformula"
              name="tpreminderfeesformula"
              col
              xs={6}
              shouldUpdate
            >
              <FormulaList
                params={{
                  ctecategory: '',
                  ctetype: 'REMINF',
                  duration: 0,
                  finamount: 0,
                  priid: 0,
                  prilabel: '',
                  pristatus: '',
                }}
              />
            </FormInput>
            <Col span={2} />
            <FormInput
              comcode="tpblockreminderfeesinvoicing"
              name="tpblockreminderfeesinvoicing"
              col
              xs={3}
              shouldUpdate
              valuePropName="checked"
            >
              <Switch
                checkedChildren={<CheckOutlined />}
                unCheckedChildren={<CloseOutlined />}
              />
            </FormInput>
          </Row>
        </Form>
      </Card>
    </Modal>
  );
};

export default Tpdisplay;
